<template>
	<div class="modal fade" role="dialog" aria-labelledby="modal-inversor-label" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
		        	<h4 class="modal-title" id="modal-inversor-label">
		        		{{form.codigo}} | {{form.nombre}}
		        	</h4>
		        	<div class="btn-group">
				        <button type="button" class="btn btn-link btn-sm" v-on:click="getData()">
				        	<i class="material-icons">refresh</i>
				        </button>
			        	<button type="button" class="btn btn-link btn-sm" data-dismiss="modal" aria-label="Close">
				        	<i class="material-icons">close</i>
				        </button>
		        	</div>
		    	</div>
		    	<preloader v-if="loading"></preloader>
		    	<div class="modal-body p-0">
		    		<ul class="nav nav-tabs" role="tablist" id="consultaInversoresTab">
						<li class="nav-item">
					    	<a class="nav-link active" id="personales-inversores-tab" data-toggle="tab" href="#personales-inversores" role="tab" aria-controls="personales-inversores" aria-selected="true">Datos</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="auditoria-inversores-tab" data-toggle="tab" href="#auditoria-inversores" role="tab" aria-controls="auditoria-inversores" aria-selected="false">Auditoría</a>
						</li>
					</ul>
					<div class="tab-content" id="consultaInversoresContent">
						<div class="tab-pane fade show active p-3" id="personales-inversores" role="tabpanel" aria-labelledby="personales-inversores-tab">
							<div class="form-row">
								<div class="col-md-6 mb-3">
									<div class="card bg-light">
										<div class="card-header text-center">
											Cuenta en quetzales
										</div>
										<div class="card-body">
											<div class="form-row">
												<div class="col-md-12">
													<label>Nombre cuenta:</label>
													<p>{{form.nombre_cuenta_q}}</p>
												</div>

												<div class="col-md-12">
													<label>Número cuenta:</label>
													<p>{{form.numero_cuenta_q}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="col-md-6 mb-3">
									<div class="card bg-light">
										<div class="card-header text-center">
											Cuenta en dólares
										</div>
										<div class="card-body">
											<div class="form-row">
												<div class="col-md-12">
													<label>Nombre cuenta:</label>
													<p>{{form.nombre_cuenta_s}}</p>
												</div>

												<div class="col-md-12">
													<label>Número cuenta:</label>
													<p>{{form.numero_cuenta_s}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="col-md-12 mb-3">
									<label>Observaciones:</label>
									<p>
										{{form.observaciones}}
									</p>
								</div>
							</div>
						</div>
						<div class="tab-pane fade p-3" id="auditoria-inversores" role="tabpanel" aria-labelledby="auditoria-inversores-tab">
							<div class="row py-3">
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Creado Por'">
											<i class="material-icons">person_add</i>
										</div>
										<div class="media-body">
											<label>Creado Por:</label>
											<p class="m-0">
												{{form.creado_por.codigo}} - {{form.creado_por.nombre}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Actualizado Por'">
											<i class="material-icons">person_outline</i>
										</div>
										<div class="media-body">
											<label>Actualizado Por:</label>
											<p class="m-0">
												{{form.actualizado_por.codigo}} - {{form.actualizado_por.nombre}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Fecha Creación'">
											<i class="material-icons">access_time</i>
										</div>
										<div class="media-body">
											<label>Fecha Creación:</label>
											<p class="m-0">
												{{form.fecha_creacion}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Fecha Actualización'">
											<i class="material-icons">update</i>
										</div>
										<div class="media-body">
											<label>Fecha Actualización:</label>
											<p class="m-0">
												{{form.fecha_actualizacion}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Creado Desde'">
											<i class="material-icons">add_location</i>
										</div>
										<div class="media-body">
											<label>Creado Desde:</label>
											<p class="m-0">
												{{form.creado_desde}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Actualizado Desde'">
											<i class="material-icons">edit_location</i>
										</div>
										<div class="media-body">
											<label>Actualizado Desde:</label>
											<p class="m-0">
												{{form.actualizado_desde}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		    	</div>
		    </div>
		</div>
	</div>
</template>
<script>
	export default {
		mounted(){
			this.modal()
		},

		data(){
			return {
				inversor: '',
				loading: false,
				form: {
					codigo: '',
					nombre: '',
					
					nombre_cuenta_q: '',
					numero_cuenta_q: '',
					nombre_cuenta_s: '',
					numero_cuenta_s: '',
					observaciones: '',

					fecha_creacion: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					}
				},
			}
		},

		methods: {
			modal: function(){
				var $module = this
				$(this.$el).on('show.bs.modal', function (event) {
					var button = $(event.relatedTarget)
					$module.inversor = button.data('codigo')
					$module.getData()
				})
			},

			getData: function(){
				this.loading = true;
				var url = 'api/inversores/'+this.inversor;

				axios.get(url)
				.then(response => {
					this.setData(response.data);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			setData: function(data){
				this.form.codigo = data.CODIGO_INVERSOR
				this.form.nombre = data.NOMBRE_INVERSOR
				
				this.form.nombre_cuenta_q = data.NOMBRE_CUENTA_Q
				this.form.numero_cuenta_q = data.NUMERO_CUENTA_Q
				this.form.nombre_cuenta_s = data.NOMBRE_CUENTA_S
				this.form.numero_cuenta_s = data.NUMERO_CUENTA_S
				this.form.observaciones = data.OBSERVACIONES

				this.form.fecha_creacion = data.FECHA_CREACION
				this.form.fecha_actualizacion = data.FECHA_ACTUALIZACION
				
				if (data.creado_por) {
					this.form.creado_por.codigo = data.creado_por.CODIGO_USUARIO
					this.form.creado_por.nombre = data.creado_por.NOMBRE
				}
				if (data.actualizado_por) {
					this.form.actualizado_por.codigo = data.actualizado_por.CODIGO_USUARIO
					this.form.actualizado_por.nombre = data.actualizado_por.NOMBRE
				}
				this.form.creado_desde = data.CREADO_DESDE
				this.form.actualizado_desde = data.ACTUALIZADO_DESDE
			}
		}
	}
</script>